import { gql } from '@apollo/client'
import { useSendOnboardCodeMutation, useVerifyOnboardCodeMutation } from '@graphql/generated'

gql`
  mutation SendOnboardCode($phoneNumber: String!, $email: String!) {
    onboardCodeSend(input: { phoneNumber: $phoneNumber, email: $email }) {
      retryInSeconds
      error
    }
  }

  mutation VerifyOnboardCode($orgName: String!, $phoneNumber: String!, $email: String!, $code: String!) {
    onboardCodeVerify(input: { orgName: $orgName, phoneNumber: $phoneNumber, email: $email, code: $code }) {
      accessToken
      error
    }
  }
`

export const useOnboarding = () => {
  const [sendCode, { loading: sendLoading }] = useSendOnboardCodeMutation()
  const [verifyCode, { loading: verifyLoading }] = useVerifyOnboardCodeMutation()

  const handleSendCode = (email: string, phoneNumber: string) =>
    sendCode({
      variables: {
        email,
        phoneNumber,
      },
    })

  const handleVerifyCode = (code: string, email: string, phoneNumber: string, orgName: string) =>
    verifyCode({ variables: { code, email, phoneNumber, orgName } })

  return { sendCode: handleSendCode, verifyCode: handleVerifyCode, loading: sendLoading ?? verifyLoading ?? false }
}
